//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import ActionBar from '../ActionBar/ActionBar';
import FilesContainer from '../FilesContainer/FilesContainer';
import FileManagerTitleBar from '../FileManagerTitleBar';
import { getFileSources, resetFileManager } from '@/redux/slices/fileManagerSlice';
import { useFileManager } from '@/components/_hooks/useFileManager';
import { useAppDispatch } from '@/redux/hooks';

const FileManager = () => {
  const dispatch = useAppDispatch();
  useFileManager();

  useEffect(() => {
    dispatch(getFileSources());

    return () => {
      dispatch(resetFileManager());
    };
  }, []);

  return (
    <>
      <FileManagerTitleBar />
      <ActionBar />
      <FilesContainer />
    </>
  );
};
export default FileManager;
